import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm">
      <ol className="flex flex-wrap items-center gap-1.5 text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-700 transition-colors">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}